export class NotificationModel {
  title: string;
  description: string;
  type: 'info' | 'warn' | 'danger';
}
